// Pathify
import {make} from 'vuex-pathify'

const state = {
  permissions: [],
}

const mutations = make.mutations(state)

const actions = {
  clear: ({commit}, state) => {
    // console.log('clear permission');
    localStorage.removeItem('vue@permission')
    commit('permissions', []);
  },
  update: ({commit}, state) => {
    commit('permissions', state);
    localStorage.setItem('vue@permission', JSON.stringify(state))
  },
  init: async ({commit, dispatch}) => {
    // console.log('init permission');
    const permissions = localStorage.getItem('vue@permission') || '[]'
    commit('permissions', JSON.parse(permissions))
  },
}

const getters = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
